<template>
<div>
 <!-- MENU USUARIOS DE GRUPO -->
         <!-- ADMINISTRACION -->
        <v-menu text nav v-if="esGrupo" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>dashboard</v-icon>
                    <span class="caption">Administración</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item to="/grupo/catalogos/certificados" @click.shift="openNew('/grupo/catalogos/certificados');">
                    <v-icon>mdi-circle-small</v-icon>Sellos de la Empresa
                </app-bar-item>
               <app-bar-item to="/grupo/catalogos/patentes" @click.shift="openNew('/grupo/catalogos/patentes');">
                    <v-icon>mdi-circle-small</v-icon>Agentes Aduanales
                </app-bar-item>
                 <app-bar-item to="/grupo/catalogos/representantes" @click.shift="openNew('/grupo/catalogos/representantes');">
                    <v-icon>mdi-circle-small</v-icon>Representante Legal
                </app-bar-item>
                <v-divider />
                   <app-bar-item to="/grupo/catalogos/usuarios" @click.shift="openNew('/grupo/catalogos/usuarios');">
                    <v-icon>mdi-circle-small</v-icon>Usuarios
                </app-bar-item>
                <app-bar-item to="/grupo/catalogos/acceso_usuarios" @click.shift="openNew('/grupo/catalogos/acceso_usuarios');">
                    <v-icon>mdi-circle-small</v-icon>Log de Accesos
                </app-bar-item>
            </v-list>
        </v-menu>
         <!-- data stage -->

        <v-menu text nav v-if="esGrupo" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>attach_file</v-icon>
                    <span class="caption">Data Stage</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item to="/grupo/datastage/cargazip" @click.shift="openNew('/grupo/datastage/cargazip');">
                    <v-icon>mdi-circle-small</v-icon>Carga Zip
                </app-bar-item>
               <app-bar-item to="/grupo/datastage/bitacorazip" @click.shift="openNew('/grupo/datastage/bitacorazip');">
                    <v-icon>mdi-circle-small</v-icon>Bitácora ZIP
                </app-bar-item>
                 <app-bar-item to="/grupo/datastage/directo_ds" @click.shift="openNew('/grupo/datastage/directo_ds');">
                    <v-icon>mdi-circle-small</v-icon>Reportes Directos DS
                </app-bar-item>
                <v-divider />
                   <app-bar-item to="/grupo/reportes/predeterminadosds" @click.shift="openNew('/grupo/reportes/predeterminadosds');">
                    <v-icon>mdi-circle-small</v-icon>Reportes Predeterminados DS
                </app-bar-item>
               <!--  <app-bar-item to="/catalogos/grupos" @click.shift="openNew('/catalogos/grupos');">
                    <v-icon>mdi-circle-small</v-icon>Reportes de Usuario
                </app-bar-item> -->
            </v-list>
        </v-menu>
          <!-- Reportes WS -->
        <v-menu text nav v-if="esGrupo" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>file_copy</v-icon>
                    <span class="caption">Reportes WS</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item to="/grupo/reportes/predeterminadosws" @click.shift="openNew('/grupo/reportes/predeterminadosws');">
                    <v-icon>mdi-circle-small</v-icon>Reportes Predeterminados
                </app-bar-item>
               <app-bar-item to="/grupo/reportes/consultar_pedimentos_detalle" @click.shift="openNew('/grupo/reportes/consultar_pedimentos_detalle');">
                    <v-icon>mdi-circle-small</v-icon>Consulta Pedimentos
                </app-bar-item>
                 <app-bar-item to="/grupo/reportes/rectificaciones" @click.shift="openNew('/grupo/reportes/rectificaciones');">
                    <v-icon>mdi-circle-small</v-icon>Rectificaciones
                </app-bar-item>
                <app-bar-item to="/grupo/vucem/lineas" @click.shift="openNew('/grupo/vucem/lineas');">
                    <v-icon>mdi-circle-small</v-icon>Lineas de Captura
                </app-bar-item>
                <app-bar-item to="/grupo/reportes/operaciones_virtuales" @click.shift="openNew('/grupo/reportes/operaciones_virtuales');">
                    <v-icon>mdi-circle-small</v-icon>Operaciones Virtuales
                </app-bar-item>
                 <app-bar-item to="/grupo/reportes/activofijo" @click.shift="openNew('/grupo/reportes/activofijo');">
                    <v-icon>mdi-circle-small</v-icon>Activo Fijo
                </app-bar-item>
                <v-menu  open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">

                        <span v-on="on" id="menuPermisosPrevios">
                            <app-bar-item @click.native="hideMenuReportes">
                                <v-icon x-small>mdi-check-decagram</v-icon>&nbsp; Analíticos Gráficos
                                <v-icon>mdi-menu-right</v-icon>
                            </app-bar-item>
                        </span>
                    </template>
                    <v-list :tile="false" nav>
                        <app-bar-item  @click.native="hideMenuReportes" to="/grupo/graficas/pedimentos_patentes_ds">
                            <v-icon>mdi-circle-small</v-icon>Aduana - Patente DS
                        </app-bar-item>
                        <app-bar-item  @click.native="hideMenuReportes" to="/grupo/graficas/pedimentos_patentes">
                            <v-icon>mdi-circle-small</v-icon>Aduana - Patente WS
                        </app-bar-item>
                        <app-bar-item  @click.native="hideMenuReportes" to="/grupo/graficas/pedimentos_transportes">
                            <v-icon>mdi-circle-small</v-icon>Medios de Transporte WS
                        </app-bar-item>
                    </v-list>
                </v-menu>
                 <app-bar-item to="/grupo/reportes/identificadoresgrupo" @click.shift="openNew('/grupo/reportes/identificadoresgrupo');">
                    <v-icon>mdi-circle-small</v-icon>Identificadores y Complementos
                </app-bar-item>
            </v-list>
        </v-menu>

 <!-- FIN USUARIOS DE GRUPO -->
</div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";

import Util from "@/util";
import axios from "axios";


export default {
    name: "menuSuperPanel",



    components: {
        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",
        fullWidth: document.documentElement.clientWidth,
        notifications: [
        ]
    }),

    computed: {
      
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
     
        is_cliente() {
            return (
                this.$local_storage.get("id_cliente") > 0
            );
        },
       
        esGrupo(){
            return this.$local_storage.get("panel_grupo") == 1 
            && this.$local_storage.get('id_grupo') > 0  
            && this.$local_storage.get("id_cliente") == 0 
            && this.$local_storage.get("es_transportista") == 0
            && this.$local_storage.get("es_agente") == 0;
        },

    },

    methods: {
        openNew: function (h) {
            window.open(h, "_blank");
        },
       


        hideMenuReportes: function () {

            var menu = document.getElementById("menuPermisosPrevios");
           

            if (menu) {
                menu.click();
            }

           
        },
    },
    
};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
